var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select-item',{attrs:{"validator":_vm.validator,"items":_vm.selectableGroups,"placeholder":"Select a Group","placeholderEmpty":"No other groups found"}})}
var staticRenderFns = []

export { render, staticRenderFns }